import { useMemo } from 'react'
import { useCommonResponseData } from 'src/customHooks/useCommonResponseData'

export const usePatientReferenceData = () => {
  const referenceEndpoints = useMemo(
    () => [
      {
        url: '/api/secure/cc/support/mentors/list',
        params: { mentorEventTypes: 'therapy-session,consultation', sendAssociatedChambers: false },
        dataKey: 'mentor',
        errorMessage: 'Failed to load mentors list',
        stateKey: 'mentors',
      },
      {
        url: '/api/secure/cc/support/clinic-brand/list',
        params: {},
        dataKey: 'clinic-brand',
        errorMessage: 'Failed to load clinic brands list',
        stateKey: 'clinicBrands',
      },
      {
        url: '/api/secure/cc/support/clinic/list',
        params: {},
        dataKey: 'clinic',
        errorMessage: 'Failed to load clinic locations list',
        stateKey: 'clinicLocations',
      },
    ],
    [],
  )

  const {
    data: referenceData,
    loading: referenceLoading,
    fetchAllEndpoints,
  } = useCommonResponseData(referenceEndpoints)

  return {
    mentors: referenceData.mentors || [],
    clinicBrands: referenceData.clinicBrands || [],
    clinicLocations: referenceData.clinicLocations || [],
    referenceData,
    loading: referenceLoading,
    fetchReferenceData: fetchAllEndpoints,
  }
}